export default __webpack_public_path__ + "static/media/twitter.568f0706.png";